import { useEffect, useState } from "react";
import styles from "./CheckBoxSelected.module.scss";
import CheckBoxIcon from "../../../assets/images/pages/login/checkBox.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

interface CheckBoxSelectedProps {
  value: string | number;
  onChange: (value: string | number) => void;
  error: string;
  target?: string | number;
  disabled?: boolean;
}

const CheckBoxSelected = ({
  value,
  onChange,
  error,
  disabled = false,
}: CheckBoxSelectedProps) => {
  const [selectedOption, setSelectedOption] = useState<string | number | null>(
    value ?? null
  );
  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    onChange(selectedOption ?? "");
  }, [selectedOption]);

  useEffect(() => {
    setSelectedOption(value ?? null);
  }, [value]);

  const handleClick = (val: string) => {
    if (!disabled) {
      setSelectedOption(val);
    }
  };

  return (
    <div className={styles.checkBoxSelectedContainer}>
      <p className={styles.checkBoxSelectedTitle}>
        {data?.auth_referal_gender_select}
      </p>
      <div className={styles.checkBoxContainer}>
        <div
          className={`${styles.checkBox} ${
            selectedOption === "1" ? styles.selected : ""
          } ${disabled ? styles.disabled : ""}`}
          onClick={() => handleClick("1")}
        >
          <span className={styles.checkBoxImg}>
            {selectedOption === "1" && (
              <img src={CheckBoxIcon} alt="CheckBox" />
            )}
          </span>
          <p className={styles.checkBoxText}>
            {data?.auth_referal_gender_male}
          </p>
        </div>

        <div
          className={`${styles.checkBox} ${
            selectedOption === "0" ? styles.selected : ""
          } ${disabled ? styles.disabled : ""}`}
          onClick={() => handleClick("0")}
        >
          <span className={styles.checkBoxImg}>
            {selectedOption === "0" && (
              <img src={CheckBoxIcon} alt="CheckBox" />
            )}
          </span>
          <p className={styles.checkBoxText}>
            {data?.auth_referal_gender_female}
          </p>
        </div>
      </div>
      <p className={styles.error_message}>{error}</p>
    </div>
  );
};

export default CheckBoxSelected;
